import { loadAndTrack } from "redux-request-loading";

import { Dispatch } from "../../store";

import { actionTaskSuccess } from "../../crud/ohCase/actions";

import { SUBMIT_PPQ_DECLARATION_REVIEW } from "./actionTypes";
import { PpqDeclarationReviewApi } from "./PpqDeclarationReviewApi";

export const submitPpqDeclarationReview = (customerId: string, ohCaseId: string, taskId: string, notes: string) =>
    async (dispatch: Dispatch) => {
        const updatedTask = await loadAndTrack(
            dispatch,
            SUBMIT_PPQ_DECLARATION_REVIEW,
            PpqDeclarationReviewApi.submit(customerId, ohCaseId, taskId, notes)
        );
        dispatch(actionTaskSuccess({ ohCaseId, tasks: [updatedTask] }));
    };
